
import SearchFilter from '../components/filters/SearchFilter'

export default {
  extends: SearchFilter
}
